"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _scrollIntoViewIfNeeded = _interopRequireDefault(require("scroll-into-view-if-needed"));
var _useList = _interopRequireDefault(require("../List/hooks/useList"));
var _Icon = require("../Icon");
var _Checkbox = require("../Checkbox");
var _types = require("./types");
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var ListItem = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a = props.type,
    type = _a === void 0 ? _types.ListItemTypes.Normal : _a,
    _b = props.scrollOnTargeted,
    scrollOnTargeted = _b === void 0 ? true : _b,
    indeterminate = props.indeterminate,
    text = props.text,
    subText = props.subText,
    icon = props.icon,
    targeted = props.targeted,
    selected = props.selected,
    value = props.value,
    actionIcon = props.actionIcon,
    onActionClick = props.onActionClick,
    onSelect = props.onSelect,
    onClick = props.onClick,
    children = props.children,
    DOMProps = __rest(props, ["type", "scrollOnTargeted", "indeterminate", "text", "subText", "icon", "targeted", "selected", "value", "actionIcon", "onActionClick", "onSelect", "onClick", "children"]);
  var listRef = (0, _useList.default)()._domRef;
  var listItemRef = (0, _react.useRef)(null);
  var isTypeNormal = type === _types.ListItemTypes.Normal;
  var isTypeSelect = type === _types.ListItemTypes.Select;
  var isTypeCheckbox = type === _types.ListItemTypes.Checkbox;
  var isTargeted = !isTypeNormal && targeted;
  (0, _react.useImperativeHandle)(ref, function () {
    return listItemRef.current;
  });
  (0, _react.useEffect)(function () {
    if (scrollOnTargeted && isTargeted && listItemRef.current) {
      (0, _scrollIntoViewIfNeeded.default)(listItemRef.current, {
        scrollMode: 'if-needed',
        behavior: 'smooth',
        boundary: listRef === null || listRef === void 0 ? void 0 : listRef.current
      });
    }
  }, [scrollOnTargeted, isTargeted, listRef]);
  var handleOnSelect = (0, _react.useCallback)(function () {
    if (typeof onSelect === 'function') {
      onSelect(value);
    }
  }, [onSelect, value]);
  var handleOnClick = (0, _react.useCallback)(function (event) {
    if (typeof onClick === 'function') {
      onClick(event);
    }
    handleOnSelect();
  }, [onClick, handleOnSelect]);
  var handleOnActionClick = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    if (typeof onActionClick === 'function') {
      onActionClick(event);
    }
  }, [onActionClick]);
  var checkmarkIcon = !actionIcon && isTypeSelect && selected ? true : false;
  return (0, _jsxRuntime.jsxs)(Styled.Wrapper, __assign({
    ref: listItemRef,
    tabIndex: -1,
    onClick: handleOnClick
  }, DOMProps, {
    "$targeted": isTargeted
  }, {
    children: [(0, _jsxRuntime.jsxs)(Styled.InnerWrapper, {
      children: [isTypeCheckbox ? (0, _jsxRuntime.jsx)(Styled.Checkbox, {
        tabIndex: -1,
        checked: selected,
        indeterminate: indeterminate,
        variant: isTargeted ? _Checkbox.CheckboxVariants.Secondary : _Checkbox.CheckboxVariants.Primary
      }) : null, icon ? (0, _jsxRuntime.jsx)(Styled.Icon, {
        icon: icon,
        size: _Icon.IconSizes.Tiny
      }) : null, (0, _jsxRuntime.jsxs)(Styled.TextWrapper, {
        children: [text ? (0, _jsxRuntime.jsx)(Styled.Text, {
          children: text
        }) : null, subText ? (0, _jsxRuntime.jsx)(Styled.SubText, {
          children: subText
        }) : null]
      }), checkmarkIcon ? (0, _jsxRuntime.jsx)(Styled.Icon, {
        icon: _Icon.Icons.Check,
        size: _Icon.IconSizes.Tiny
      }) : null, actionIcon ? (0, _jsxRuntime.jsx)(Styled.ActionIcon, {
        icon: actionIcon,
        size: _Icon.IconSizes.Tiny,
        onClick: handleOnActionClick
      }) : null]
    }), children]
  }));
});
ListItem.displayName = 'ListItem';
var _default = ListItem;
exports.default = _default;